module.exports = __webpack_public_path__ + "static/media/calendar-edit.64e2598b.svg";